import React, { Fragment, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import Logo from "../assets/logo";
import {
    Facebook,
    Instagram,
    Phone,
    Twitter,
    WhatsApp,
} from "@mui/icons-material";
import Whatsapp from "../assets/whatsapp";
import { Link } from "react-router-dom";

function Footer() {
    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);

        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    const isMobile = width <= 768;

    return (
        <Fragment>
            <Grid
                container
                marginLeft={isMobile ? 4 : 8}
                marginTop={6}
                gap={8}
                maxWidth={"95%"}
            >
                <Grid xs={12} md={2}>
                    <Logo />
                    <Typography
                        marginY={1}
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="400"
                        fontSize="14px"
                        lineHeight="20px"
                        color="#202020"
                    >
                        Sindicato dos Trabalhadores na Administração Pública e
                        Autarquias no Município de São Paulo
                    </Typography>
                </Grid>
                <Grid xs={12} md={2}>
                    <Typography
                        marginY={1}
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="700"
                        fontSize="16px"
                        lineHeight="20px"
                        color="#C81E1E"
                    >
                        Sede
                    </Typography>
                    <Typography
                        marginY={1}
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="400"
                        fontSize="14px"
                        lineHeight="20px"
                        color="#202020"
                    >
                        Rua da Quitanda, 101 - Centro São Paulo - SP
                    </Typography>

                    <a
                        href="tel:1121292999"
                        aria-label="Ligar para 11 2129 2999"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            marginTop: 8,
                            fontFamily: "Raleway",
                            fontStyle: "normal",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "20px",
                            color: "#202020",
                            textDecoration: "none",
                            marginRight: 50,
                        }}
                    >
                        <Phone style={{ width: 16 }} />
                        11 2129 2999
                    </a>
                    <a
                        href="https://api.whatsapp.com/send?phone=5511970255497"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="WhatsApp 11 97025-5497 "
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            marginTop: 8,
                            fontFamily: "Raleway",
                            fontStyle: "normal",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "20px",
                            color: "#202020",
                            textDecoration: "none",
                        }}
                    >
                        <WhatsApp style={{ width: 16 }} />
                        11 97025-5497
                    </a>
                </Grid>
                <Grid xs={12} md={1}>
                    <Typography
                        marginY={1}
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="700"
                        fontSize="16px"
                        lineHeight="20px"
                        color="#C81E1E"
                    >
                        Nossas Redes
                    </Typography>
                    <Box>
                        <a
                            aria-label="Facebook do Sindsep "
                            href="https://www.facebook.com/sindsep"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <Facebook style={{ color: "#202020" }} />
                        </a>
                        <a
                            aria-label="Instagram do Sindsep "
                            href="https://www.instagram.com/sindsepsp"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <Instagram style={{ color: "#202020" }} />
                        </a>
                        <a
                            aria-label="Twitter do Sindsep "
                            href="https://twitter.com/sindsep"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <Twitter style={{ color: "#202020" }} />
                        </a>
                    </Box>
                    <Link
                        to="/assessoria"
                        style={{
                            textDecoration: "none",
                        }}
                    >
                        <Typography
                            marginY={3}
                            fontFamily="Raleway"
                            fontStyle="normal"
                            fontWeight="700"
                            fontSize="16px"
                            lineHeight="20px"
                            color="#C81E1E"
                        >
                            Assessoria de Imprensa
                        </Typography>
                    </Link>
                </Grid>

                <Grid xs={12} md={3}>
                    <a
                        href="https://api.whatsapp.com/send?phone=5511970255497"
                        target={"_blank"}
                        rel="noreferrer"
                        style={{
                            color: "#202020",
                            textDecoration: "none",
                            textTransform: "lowercase",
                        }}
                    >
                        <Typography
                            marginY={1}
                            fontFamily="Raleway"
                            fontStyle="normal"
                            fontWeight="700"
                            fontSize="16px"
                            lineHeight="20px"
                            color="#C81E1E"
                        >
                            Participe do nosso grupo
                        </Typography>
                        <Typography
                            marginY={1}
                            fontFamily="Raleway"
                            fontStyle="normal"
                            fontWeight="400"
                            fontSize="14px"
                            lineHeight="20px"
                            color="#202020"
                        >
                            Receba as novidades do Sindsep no WhatsApp
                        </Typography>

                        <Box
                            component="span"
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 1,
                                borderRadius: 100,
                                backgroundColor: "#1a6b2a",
                                border: "1px solid #1a6b2a",
                                color: "#FFFFFF",
                                padding: "8px 16px",
                                fontFamily: "Raleway",
                                fontStyle: "normal",
                                fontWeight: "600",
                                fontSize: "16px",
                                lineHeight: "20px",
                                marginTop: "20px",
                                textTransform: "uppercase",
                            }}
                        >
                            <Whatsapp />
                            ASSINAR WHATSAPP
                        </Box>
                        <span className="sr-only"> </span>
                    </a>
                </Grid>
            </Grid>
            <Box marginLeft={isMobile ? 4 : 8} marginTop={2} marginBottom={4}>
                <img
                    src="../files/fetam.png"
                    style={{ marginRight: 24 }}
                    alt="Logo da FETAM"
                />
                <img
                    src="../files/cut.png"
                    style={{ marginRight: 24 }}
                    alt="Logo da CUT"
                />
                <img
                    src="../files/confetam.png"
                    style={{ marginRight: 24 }}
                    alt="Logo da CONFETAM"
                />
                <img
                    src="../files/psi.png"
                    style={{ marginRight: 24 }}
                    alt="Logo da PSI"
                />
                <img
                    src="../files/contram.png"
                    style={{ marginRight: 24 }}
                    alt="Logo da CONTRAM"
                />
                <img
                    src="../files/tvt.png"
                    style={{ marginRight: 24 }}
                    alt="Logo da TVT"
                />
                <img
                    src="../files/rba.png"
                    style={{ marginRight: 24 }}
                    alt="Logo da RBA"
                />
            </Box>
        </Fragment>
    );
}

export default Footer;
